import MainService from "@/services/MainService.js";
import dataTable from "@/components/Datatable";
import Loader from "@/components/Loader";
window.$ = window.jQuery = require("jquery");

export default {
    name: "TipoPage",
    data() {
        let ss = new MainService();
        return {
            msg: "TipoPage",
            ss: ss,
            auth: {},
            ajax: {
                "url": ss.indexTipo(),
                headers: ss.getToken(),
            },
            columns: [
                { data: 'id', name: 'id', orderable: false, searchable: false, visible: false },
                { data: 'DT_RowIndex', name: 'DT_RowIndex', title: 'N', orderable: false, searchable: false },
                { data: 'Tipo', name: 'Tipo', title: 'Tipo' },
                {
                    data: 'action',
                    orderable: false,
                    title: 'Acciones',
                    searchable: false
                },
            ],
            tipos: [],
            tipo: {},
            isLoading: false,
            errorBag: {}
        };
    },
    methods: {
        newTipo() {
            this.tipo = {};
            this.$refs['frm-tipo'].show();
        },
        showTipo(id) {
            console.log("aaa");
            this.isLoading=true;
            this.ss.showTipo(id).then(
                (result) => {
                    let response = result.data;
                    this.tipo = response.data;
                    console.log(this.tipo);

                    this.$refs['view-tipo'].show();
                    this.isLoading=false;
                    
                }
            ).catch(error => {
                console.log(error);
                this.isLoading=false;
            });
        },
        editTipo() {
            this.$refs['frm-tipo'].show();
            this.$refs['view-tipo'].hide();
        },
        cancelTipo() {
            if (this.tipo.id) {
                this.$refs['view-tipo'].show();
            }
            this.$refs['frm-tipo'].hide();
        },
        saveTipo() {
            this.ss.storeTipo(this.tipo).then(
                (result) => {
                    console.log(result);
                    let response = result.data;
                    this.$bvToast.toast(
                        response.msg,
                        {
                            title: 'Correcto',
                            variant: 'success',
                            autoHideDelay: 5000
                        }
                    )
                    //this.$refs['view-consulta'].show(); //para volver al modal
                    console.log(response);
                    this.$refs['frm-tipo'].hide();
                    this.$refs['datatable-tipo'].reload();
                })
                .catch((error) => {
                    this.errorBag = error.response.data.errors;
                    this.$bvToast.toast(
                        'Problema al Guardar el Registro, favor verificar los Datos',
                        {
                            title: 'Error',
                            variant: 'danger',
                            autoHideDelay: 5000
                        }
                    )
                });
        },
        deleteTipo() {
            this.$swal({
                title: "Estas seguro que deseas eliminar?",
                text: "Esta accion es irreversible!",
                icon: "warning",
                buttons: true,
                dangerMode: true,
                showCancelButton: true,
                cancelButtonColor: '#d33',
            })
                .then((willDelete) => {
                    if (willDelete.isConfirmed) {
                        this.ss.destroyTipo(this.tipo)
                            .then((result) => {
                                let response = result.data;
                                console.log(response);
                                this.$bvToast.toast(
                                    response.msg,
                                    {
                                        title: 'Correcto',
                                        variant: 'success',
                                        autoHideDelay: 5000
                                    }
                                )
                                this.$refs['view-tipo'].hide();
                                this.$refs['datatable-tipo'].reload();
                            })
                            .catch(error => {
                                console.log(error);
                            })
                    } else {
                        //swal("Your imaginary file is safe!");
                    }
                });
        },
        draw() {
            window.$('.btn-datatable-Tipo').on('click', (evt) => {
                const data = window.$(evt.target)[0].id;
                // console.log(data);
                this.showTipo(data);
            });
        }
    },
    components: {
        dataTable,
        Loader
    },
    mounted() {
        var persona = JSON.parse(localStorage.getItem('persona'));
        this.auth = JSON.parse(localStorage.getItem("persona"));
        if (!persona) {
          this.$router.push('/Login');
        }
    }
};
